import createAPIServices from "./createApiServices"

const prefixURL = process.env.REACT_APP_URL_PLF || 'https://manager-qa.merch8.com'
const api = createAPIServices({baseUrl: prefixURL})

export const getLanguageStore = (storeName) => {
    return api.makeBasicAuthRequest({
        url: `/api/manager/private/stores/${storeName}/preferred-language`,
        method: 'GET'
    })
}
